import React, {memo} from 'react';
import {Handle, Position} from 'reactflow';

import {Box, List, ListItem, ListItemIcon, ListItemText, Stack, Tooltip, Typography} from "@mui/material";
import {
  IconBroadcast,
  IconCornerRightDownDouble, IconLock, IconSitemap, IconWand,
} from "@tabler/icons-react";
import {grey} from "@mui/material/colors";


function CustomNode({id, data}) {
  const {name, type, icon, greet, node} = data;
  var steps = data.steps || [];
  const totalSteps = steps?.length;

  const nextRoute = steps?.find(item => item?.type === "next");
  const noMatchRoute = steps?.find(item => item?.type === "no_match");
  const failRoute = steps?.find(item => item?.type === "fail");
  steps = steps?.filter(item => !["next", "no_match", "fail", "data"].includes(item?.type))
  const isProtected = node?.data?.data_protection || false;

  return (
    <Tooltip title={totalSteps === 0 ? "Please connect node with other node" : name}>
      <Box
        className={`node custom-node ${node?.data?.use_llm ? "magic-node" : ""}`}
        // className={`node custom-node`}
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
          width: "100%",
          bgcolor: totalSteps === 0 ? 'rgb(252,252,217)' : "#d3e5f4",
          border: 1,
          borderRadius: "8px",
          borderColor: totalSteps === 0 ? "rgb(239,239,170)" : "#d3e5f4",
          boxShadow: 1
        }}>
        <Handle type="target" position={Position.Left} id={id} style={{top: 15}}/>
        <div className="custom-node__header"
             style={{
               borderRadius: "inherit",
               border: 0,
               position: "relative",
               padding: "6px",
               paddingBottom: 4,
               margin: "3px 0"
             }}>

          <Stack direction={"row"} gap={0.5} justifyContent={"flex-end"} sx={{position: "absolute", top: -14}}>
            {isProtected &&
              <Tooltip title={"Data Protection"}><IconLock stroke={1.5} size={9} color={grey[900]}/></Tooltip>}
            {node?.data?.use_llm &&
              <Tooltip title={"Use LLM Booster"}><IconWand stroke={1.5} size={9} color={grey[900]}/></Tooltip>}
            {node?.data?.global_intents_included &&
              <Tooltip title={"Include Global Intents"}><IconBroadcast stroke={1.5} size={9}
                                                                       color={grey[900]}/></Tooltip>}
          </Stack>
          <Stack direction={"row"} gap={0.5} sx={{px: 0.5}}>
            {icon || <IconSitemap size={9} stroke={1}/>}
            <Typography noWrap sx={{fontSize: 8, fontWeight: 500, color: "dark.main"}}>{name}</Typography>
          </Stack>
          <Handle type="source" position={Position.Right} className={"static next border-shadow"}
                  style={{top: 0, transform: "translateY(0)"}} id={nextRoute?.id}/>
          <Handle type="source" position={Position.Right} className={"static no-match border-shadow"}
                  style={{top: "12px"}}
                  id={noMatchRoute?.id}/>
          <Handle type="source" position={Position.Right} className={"static fail border-shadow"}
                  style={{top: "22px"}} id={failRoute?.id}/>
        </div>
        {greet && <>
          <Box
            className={"greet-message"}
            sx={{
              position: "relative",
              // borderBottom: totalSteps > 0 ? 1 : 0,
              // borderColor: "divider",
              px: 1,
              py: 0.5,
              mb: steps?.length > 0 ? 0.1 : 0,
              bgcolor: "#fff",
              borderTopRightRadius: "inherit",
              borderTopLeftRadius: "inherit",
              borderBottomRightRadius: steps?.length === 0 ? "inherit" : 0,
              borderBottomLeftRadius: steps?.length === 0 ? "inherit" : 0,
            }}>
            <Tooltip
              title={<span style={{fontSize: 13, fontFamily: "inherit"}}>{greet || <em>No greet message</em>}</span>}
            >
              <Typography noWrap fontSize={9}>{greet || <em>No greet message</em>}</Typography>
            </Tooltip>
          </Box>
          {/*{totalSteps > 0 && <Divider />}*/}
        </>
        }

        <Box className="custom-node__body" style={{
          borderRadius: 0,
          borderBottomRightRadius: "inherit",
          borderBottomLeftRadius: "inherit",
          background: "#FFF"
        }}>
          <List sx={{p: 0, m: 0,}}>
            {steps?.filter(step => step !== null)
              .map((step, index) => {
                return <ListItem
                  key={step?.id}
                  sx={{
                    px: 0.5,
                    py: 0.1,
                    m: 0,
                    textAlign: "center",
                    borderBottom: index < steps?.length - 1 ? 1 : 0,
                    borderColor: "divider"
                  }}
                  className="custom-node__select"
                >
                  <ListItemIcon sx={{minWidth: 20}}>
                    {step?.icon || <IconCornerRightDownDouble color={"#252525"} size={12}/>}
                  </ListItemIcon>
                  <ListItemText sx={{p: 0}}>
                    <Typography
                      sx={{
                        flex: 1,
                        whiteSpace: "normal",         // Allow wrapping
                        overflowWrap: "break-word",   // Break long words
                        wordBreak: "break-word",      // Break long words or strings with underscores
                        fontWeight: 600,
                        fontSize: 8,
                        color: grey[600]
                      }}
                      align="left"
                    >
                      {step?.secondary}
                    </Typography>

                    <Handle type="source" className={"dynamic"} position={Position.Right} id={step?.id}/>
                  </ListItemText>
                </ListItem>
              })}
          </List>

        </Box>


      </Box>
    </Tooltip>
  )
}

export default memo(CustomNode);